import { render, staticRenderFns } from "./RechargeNotice.vue?vue&type=template&id=247ff3de&scoped=true"
import script from "./RechargeNotice.vue?vue&type=script&lang=js"
export * from "./RechargeNotice.vue?vue&type=script&lang=js"
import style0 from "./RechargeNotice.vue?vue&type=style&index=0&id=247ff3de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247ff3de",
  null
  
)

export default component.exports